// extracted by mini-css-extract-plugin
export default {"flag-image":"LanguageSelection_flag-image__j51Z2","language-text":"LanguageSelection_language-text__n5jt5"};